import "@/components/custom-flatpickr-limpar/index.scss";


function getEventTarget (event) {
	try {
		if (typeof event.composedPath === "function") {
			const path = event.composedPath();
			return path[0];
		}
		return event.target;
	} catch (error) {
		return event.target;
	}
}

const defaultConfig = {
	//confirmIcon: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='17' height='17' viewBox='0 0 17 17'> <g> </g> <path d='M15.418 1.774l-8.833 13.485-4.918-4.386 0.666-0.746 4.051 3.614 8.198-12.515 0.836 0.548z' fill='#000000' /> </svg>",
	confirmIcon: '<button type="button" name="button" class="vs-component vs-button vs-button-danger vs-button-filled includeIcon w-full {{size}}"><span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span><i class="vs-icon notranslate icon-scale vs-button--icon  feather icon-trash" style="order: 2; margin-right: 0px; margin-left: 5px;"></i><span class="vs-button-text vs-button--text">{{confirmText}}</span><span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span></button>',
	confirmText: "Limpar",
	showAlways: false,
	size: '',
	theme: "light",
};

function customFlatpickrClearDatePlugin (pluginConfig) {
	const config = { ...defaultConfig, ...pluginConfig };
	let confirmContainer;
	const confirmButtonCSSClass = "custom-flatpickr-clear-date";

	return function (fp) {
		//if (fp.config.noCalendar || fp.isMobile) return {};
		if (fp.isMobile || fp.config.inline) return {};
		return {
			/*onKeyDown (_, __, ___, e) {
				const eventTarget = getEventTarget(e);
				const isTargetLastFocusableElement =
					(!fp.config.time_24hr && eventTarget === fp.amPM) ||
					(fp.config.time_24hr &&
						((fp.config.enableSeconds && eventTarget === fp.secondElement) ||
							(!fp.config.enableSeconds && eventTarget === fp.minuteElement)));
				if (
					fp.config.enableTime &&
					e.key === "Tab" &&
					isTargetLastFocusableElement
				) {
					e.preventDefault();
					confirmContainer.focus();
				} else if (e.key === "Enter" && eventTarget === confirmContainer) {
					fp.close();
				}
			},*/

			onReady () {
				confirmContainer = fp._createElement(
					"div",
					`${confirmButtonCSSClass} ${config.showAlways ? "visible" : ""} ${config.theme
					}Theme`,
					!config.confirmIcon ? config.confirmText : ''
				);


				confirmContainer.tabIndex = -1;
				if (config.confirmIcon) {
					var html = config.confirmIcon;
					html = html.replace('{{size}}', config.size ?? '');
					html = html.replace('{{confirmText}}', config.confirmText ?? '');
					confirmContainer.innerHTML += html;
				}
				//confirmContainer.innerHTML += config.confirmIcon;
				//confirmContainer.innerHTML += '<button type="button" name="button" class="vs-component vs-button w-full vs-button-warning vs-button-filled"><span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span><!----><span class="vs-button-text vs-button--text">Voltar</span><span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span></button>';
				//confirmContainer.innerHTML += '<button type="button" name="button" class="vs-component vs-button vs-button-danger vs-button-filled includeIcon w-full '+config.size+'"><span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span><i class="vs-icon notranslate icon-scale vs-button--icon  feather icon-trash" style="order: 2; margin-right: 0px; margin-left: 5px;"></i><span class="vs-button-text vs-button--text">' + config.confirmText + '</span><span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span></button>';

				if (!fp.config.inline) {
					confirmContainer.classList.add("visible");
				}


				var btn = confirmContainer.querySelector('button');
				if (config.confirmIcon && btn) {
					btn.addEventListener("click", () => {
						if (fp && fp.selectedDates && fp.selectedDates.length > 0) {
							fp.clear();
							fp.close();
						}
					});
					if (fp.selectedDates && fp.selectedDates.length > 0) {
						btn.disabled = false;
					} else {
						btn.disabled = true;
					}
				} else {
					confirmContainer.addEventListener("click", () => {
						if (fp && fp.selectedDates && fp.selectedDates.length > 0) {
							fp.clear();
							fp.close();
						}
					});
				}
				fp.calendarContainer.appendChild(confirmContainer);

				fp.loadedPlugins.push("customFlatpickrClearDate");
			},
			...(!config.showAlways
				? {
					onChange: function (_, dateStr) {
						const showCondition = true;
						/*fp.config.enableTime ||
						fp.config.mode === "multiple" ||
						fp.loadedPlugins.indexOf("monthSelect") !== -1;*/

						const localConfirmContainer = fp.calendarContainer.querySelector(
							`.${confirmButtonCSSClass}`
						);

						if (!localConfirmContainer) return;

						if (
							!fp.config.inline &&
							showCondition &&
							localConfirmContainer
						) {
							var btn = localConfirmContainer.querySelector('button');
							if (btn) {
								if (dateStr) {
									btn.disabled = false;
								} else {
									btn.disabled = true;
								}
							}
							return localConfirmContainer.classList.add("visible");
						}

						localConfirmContainer.classList.remove("visible");
					},
				}
				: {}),
		};
	};
}

export default customFlatpickrClearDatePlugin;
